import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import theme from "./theme";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./Providers/AuthProvider.tsx";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { store } from "./store";
import "./index.css";
import "katex/dist/katex.min.css";
import "./firebase.ts";
import BottomSheet from "./components/BottomSheet/index.tsx";
import { AudioProvider } from "./Providers/AudioProvider.tsx";
import posthog from "posthog-js";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
});

posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
  api_host: "https://us.i.posthog.com",
  person_profiles: "identified_only",
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <AuthProvider>
      <AudioProvider>
        <ChakraProvider theme={theme}>
          <ColorModeScript initialColorMode={theme.config.initialColorMode} />
          <QueryClientProvider client={queryClient}>
            <App />
            <BottomSheet />
            {/* <ReactQueryDevtools initialIsOpen={false} /> */}
          </QueryClientProvider>
        </ChakraProvider>
      </AudioProvider>
    </AuthProvider>
  </Provider>
);

// <React.StrictMode>
